import AreaSelectModal from '@pc/components/Works/Panel/SelectModal/AreaSelectModal'
import StationSelectModal from '@pc/components/Works/Panel/SelectModal/StationSelectModal'
import ButtonGroup from '@pc/components/Works/Panel/shared/Button/ButtonGroup'
import ConditionParagraph from '@pc/components/Works/Panel/shared/ConditionParagraph'
import EmphasisHeading from '@pc/components/Works/Panel/shared/Heading/EmphasisHeading'
import type { SearchParamsAttributes, ConditionReducer } from '@pc/components/Works/Panel/types'
import buildConditionWords from '@pc/components/Works/Panel/utils/buildConditionWords'
import BaseSelectPanel from './BaseSelectPanel'

interface PropsType {
  params: SearchParamsAttributes
  conditionReducer: ConditionReducer
}

const AreaSelectPanel = (props: PropsType) => {
  const { params, conditionReducer } = props

  const el = document.querySelector<HTMLElement>('.js-works-search-panel')
  const prefectureAttr = el?.dataset.worksPrefecture
  const prefecture = prefectureAttr !== undefined ? JSON.parse(prefectureAttr).data : undefined

  const citiesAttr = el?.dataset.worksCities
  const cities = citiesAttr !== undefined ? JSON.parse(citiesAttr).data : undefined

  const rawLineCompaniesAttr = el?.dataset.worksLineCompanies
  const linesAttr = el?.dataset.worksLines
  const stationsAttr = el?.dataset.worksStations
  const stationData =
    rawLineCompaniesAttr !== undefined && linesAttr !== undefined && stationsAttr !== undefined
      ? {
          rawLineCompanies: JSON.parse(rawLineCompaniesAttr).data,
          lines: JSON.parse(linesAttr).data,
          stations: JSON.parse(stationsAttr).data
        }
      : undefined

  const currentConditions = () => {
    const areaTitles = [
      conditionReducer.attributes.condition_title_maps.city_ids,
      conditionReducer.attributes.condition_title_maps.line_ids,
      conditionReducer.attributes.condition_title_maps.station_ids
    ]
      .flat()
      .filter((v): v is string => v != null)

    return <ConditionParagraph>{buildConditionWords(areaTitles)}</ConditionParagraph>
  }

  return (
    <BaseSelectPanel>
      <EmphasisHeading>エリア・駅</EmphasisHeading>
      {currentConditions()}
      <ButtonGroup>
        {cities && prefecture && <AreaSelectModal params={params} prefecture={prefecture} cities={cities} />}
        {stationData && prefecture && (
          <StationSelectModal
            params={params}
            prefecture={prefecture}
            rawLineCompanies={stationData.rawLineCompanies}
            lines={stationData.lines}
            stations={stationData.stations}
          />
        )}
      </ButtonGroup>
    </BaseSelectPanel>
  )
}

export default AreaSelectPanel
